// import { useEffect } from 'react';
// import Accordion from 'react-bootstrap/Accordion';
// import { useAppDispatch, useAppSelector } from '@store/hooks';
// import { getJournalsByReferenceId } from '@store/Finance/Journals/JournalsSlice';
// import { Badge, Form } from 'react-bootstrap';
// import { useTranslation } from 'react-i18next';
// import Lines from './Lines';
// import Loading from '@components/Shared/Loader/Loading';

// interface Props {
//   referenceId: string;
// }

// const JournalsByReference = ({ referenceId }: Props) => {
//   const { t, i18n } = useTranslation();
//   const dispatch = useAppDispatch();

//   useEffect(() => {
//     dispatch(
//       getJournalsByReferenceId({
//         ReferenceId: referenceId,
//         JeCategory: '',
//         JeSource: ''
//       })
//     );
//   }, [dispatch, referenceId]);
//   const { JournalsByReferenceId: data, loading, error } = useAppSelector(s => s.Journals);

//   // دالة موحدة لإرجاع معلومات الحالة (النص واللون)
//   const getStatusInfo = (status: any) => {
//     switch (status) {
//       case 'U':
//         return { variant: 'warning', text: t('غير مرحل ') };
//       case 'P':
//         return { variant: 'success', text: t('مرحل') };
//       default:
//         return { variant: 'secondary', text: t('Unknown') };
//     }
//   };

//   return (
//     <>
//       <Loading loading={loading} error={error} Type='Dots'>
//         <>
//           <div className='row mb-4'>
//             <div className='col-lg-3 col-md-6'>
//               <div className='form-group mb-3'>
//                 <label className='form-label'>{t('الإستاذ العام')}</label>
//                 <Form.Control
//                   className='form-control text-center fw-bold'
//                   value={i18n.language === 'ar' ? data[0]?.ledgerName2 : data[0]?.ledgerName || ''}
//                   readOnly
//                 />
//               </div>
//             </div>
//             <div className='col-lg-3 col-md-6'>
//               <div className='form-group mb-3'>
//                 <label className='form-label'>{t('AccountingPeriod')}</label>
//                 <Form.Control
//                   className='form-control text-center fw-bold'
//                   value={i18n.language === 'ar' ? data[0]?.periodName2 : data[0]?.periodName || ''}
//                   readOnly
//                 />
//               </div>
//             </div>
//             <div className='col-lg-3 col-md-6'>
//               <div className='form-group mb-3'>
//                 <label className='form-label'>{t('Date')}</label>
//                 <Form.Control className='form-control fw-bold text-center' value={data[0]?.glDate || ''} readOnly />
//               </div>
//             </div>
//             <div className='col-lg-3 col-md-6'>
//               <div className='form-group mb-3'>
//                 <label className='form-label'>{t('Source')}</label>
//                 <Form.Control
//                   className='form-control fw-bold text-center'
//                   value={i18n.language === 'ar' ? data[0]?.jeSourceName2 : data[0]?.jeSourceName || ''}
//                   readOnly
//                 />
//               </div>
//             </div>

//           </div>

//           <Accordion defaultActiveKey='0'>
//             {data?.map((journal, index) => {
//               const statusInfo = getStatusInfo(journal.status);

//               return (
//                 <Accordion.Item eventKey={index.toString()} key={journal.id || index}>
//                   <Accordion.Header>
//                     <div className='d-flex justify-content-between align-items-center w-100'>
//                       <div className='d-flex align-items-center'>
//                         {/* الترقيم الديناميكي */}
//                         <span className='badge bg-secondary me-2 p-2'>{index + 1}</span>

//                         {/* أيقونة باستخدام <i> */}
//                         <i className='bi bi-journal-text me-2 text-theme fs-4'></i>

//                         {/* اسم اليومية */}
//                         {i18n.language === 'en' ? journal.name : journal.name2}

//                         {/* شارة حالة الـ Journal */}
//                         <Badge bg={statusInfo.variant} className='ms-2 p-1'>
//                           {statusInfo.text}
//                         </Badge>
//                       </div>
//                     </div>
//                   </Accordion.Header>
//                   <Accordion.Body>
//                     <Lines
//                       JournalLine={journal.glJeLinesList}
//                       CategoryName={i18n.language === 'en' ? journal?.jeCategoryName : journal?.jeCategoryName2}
//                     />
//                   </Accordion.Body>
//                 </Accordion.Item>
//               );
//             })}
//           </Accordion>
//         </>
//       </Loading>
//     </>
//   );
// };

// export default JournalsByReference;

import { useEffect } from 'react';
import { Badge, Form } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

import { useAppDispatch, useAppSelector } from '@store/hooks';
import { getJournalsByReferenceId } from '@store/Finance/Journals/JournalsSlice';

import Lines from './Lines';
import Loading from '@components/Shared/Loader/Loading';
import { Card, CardHeader, CardBody } from '@components/card/card';

interface Props {
  referenceId: string;
}

const JournalsByReference = ({ referenceId }: Props) => {
  const { t, i18n } = useTranslation();
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(
      getJournalsByReferenceId({
        ReferenceId: referenceId,
        JeCategory: '',
        JeSource: ''
      })
    );
  }, [dispatch, referenceId]);

  const { JournalsByReferenceId: data, loading, error } = useAppSelector(s => s.Journals);
  // console.log('JournalsByReferenceId data:', JSON.stringify(data, null, 2));

  const getStatusInfo = (status: any) => {
    switch (status) {
      case 'U':
        return { variant: 'warning', text: t('غير مرحل ') };
      case 'P':
        return { variant: 'success', text: t('مرحل') };
      default:
        return { variant: 'secondary', text: t('Unknown') };
    }
  };

  const headerLedger = (i18n.language === 'ar' ? data?.[0]?.ledgerName2 : data?.[0]?.ledgerName) || '';
  const headerPeriod = (i18n.language === 'ar' ? data?.[0]?.periodName2 : data?.[0]?.periodName) || '';
  const headerDate = data?.[0]?.glDate || '';
  const headerSource = (i18n.language === 'ar' ? data?.[0]?.jeSourceName2 : data?.[0]?.jeSourceName) || '';

  return (
    <>
      <Loading loading={loading} error={error} Type='Dots'>
        <>
          <Card className='mb-4'>
            <CardBody>
              <div className='row '>
                <div className='col-lg-3 col-md-6'>
                  <div className='form-group mb-3'>
                    <label className='form-label'>{t('الإستاذ العام')}</label>
                    <Form.Control className='form-control text-center fw-bold' value={headerLedger} readOnly />
                  </div>
                </div>

                <div className='col-lg-3 col-md-6'>
                  <div className='form-group mb-3'>
                    <label className='form-label'>{t('AccountingPeriod')}</label>
                    <Form.Control className='form-control text-center fw-bold' value={headerPeriod} readOnly />
                  </div>
                </div>

                <div className='col-lg-3 col-md-6'>
                  <div className='form-group mb-3'>
                    <label className='form-label'>{t('Date')}</label>
                    <Form.Control className='form-control fw-bold text-center' value={headerDate} readOnly />
                  </div>
                </div>

                <div className='col-lg-3 col-md-6'>
                  <div className='form-group mb-3'>
                    <label className='form-label'>{t('Source')}</label>
                    <Form.Control className='form-control fw-bold text-center' value={headerSource} readOnly />
                  </div>
                </div>
              </div>
            </CardBody>
          </Card>

          {/* ✅ Parent container لتحقيق سلوك الأكورديون (يفتح واحد فقط) */}
          <div id='journalsByRefParent'>
            {data?.map((journal, index) => {
              const statusInfo = getStatusInfo(journal.status);

              // ✅ IDs آمنة وفريدة
              const key = journal.id || index;
              const collapseId = `jrnl_${key}`;
              const showClass = index === 0 ? 'show' : '';

              return (
                <Card className='mb-3' key={key}>
                  <CardHeader
                    className='d-flex justify-content-between align-items-center'
                    style={{ cursor: 'pointer' }}
                  >
                    <div className='d-flex align-items-center'>
                      {/* <span className='badge bg-secondary me-2 p-2'>{index + 1}</span> */}
                      <i className='bi bi-journal-text me-2 text-theme fs-4'></i>

                      {/* <span className='fw-semibold'>{i18n.language === 'en' ? journal.name : journal.name2}</span> */}
                      {/* عرض الكود ثم الاسم مع فاصل */}
                      <div className='fw-semibold'>
                        <span className='fw-bold text-theme'>
                          {journal.code} {' - '}
                        </span>
                        {i18n.language === 'en' ? journal.name : journal.name2}
                      </div>
                      <Badge bg={statusInfo.variant as any} className='ms-2 p-1'>
                        {statusInfo.text}
                      </Badge>
                    </div>

                    <a
                      role='button'
                      className='text-inverse text-opacity-50'
                      data-bs-toggle='collapse'
                      data-bs-target={`#${collapseId}`}
                      aria-controls={collapseId}
                      aria-expanded={index === 0 ? 'true' : 'false'}
                      onClick={e => e.preventDefault()}
                    >
                      <i className='fa fa-plus-circle'></i>
                    </a>
                  </CardHeader>

                  <div id={collapseId} className={`collapse ${showClass}`} data-bs-parent='#journalsByRefParent'>
                    <CardBody>
                      <Lines
                        JournalLine={journal.glJeLinesList}
                        CategoryName={i18n.language === 'en' ? journal?.jeCategoryName : journal?.jeCategoryName2}
                      />
                    </CardBody>
                  </div>
                </Card>
              );
            })}
          </div>
        </>
      </Loading>
    </>
  );
};

export default JournalsByReference;
